import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Styled } from 'app/features/pricingPromo/landing/components/megaFanPerks/perks/components/Perk.styled';
import Text from 'app/components/layout/Text.styled';

const OfflineViewing = () => (
  <Styled.Perk data-t="offline-viewing-perk">
    <Styled.PerkIcon
      role="img"
      color="--colors-honey-gold-base"
      viewBox="0 0 40 40"
    >
      <path d="M36.251 3.866a6.838 6.838 0 0 0-1.354-1.072c-.865-.522-1.813-.821-2.833-.792l-.27.015c-1.34.106-2.586.715-3.708 1.775l-3.182 3.18-12.85-3.874-6.128 6.129 11.354 5.37-2.996 2.996-6.435-.451L1 23.99l12.11 2.996 2.767 11.948 6.894-6.894-.578-6.56 2.993-2.993 5.496 11.48 6.121-6.121-3.875-12.85 3.152-3.151c1.226-1.252 1.881-2.583 1.881-3.99 0-1.627-.78-3.06-1.71-3.99zm-1.956 1.776c.42.42.832 1.175.832 1.867 0 .536-.306 1.158-1.014 1.88l-4.41 4.41 3.875 12.85-1.855 1.855-5.497-11.479-6.979 6.979.577 6.56-2.08 2.08-1.96-8.471-8.74-2.164 2.124-2.124 6.435.452 6.975-6.975L11.225 7.99l1.847-1.847 12.85 3.875 4.42-4.42c.658-.621 1.313-.924 1.974-.943.705-.02 1.38.387 1.98.987z" />
    </Styled.PerkIcon>
    <Text as={Styled.PerkDescription} size="l">
      <FormattedMessage id="pricing_promo_landing_perks_offline_viewing" />
    </Text>
  </Styled.Perk>
);

OfflineViewing.displayName = 'OfflineViewing';

export default OfflineViewing;
